import React, { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import EmptyLayout from "../../layout/EmptyLayout.tsx";
import trulogo from "../../images/logo/logo.png";
import { useTranslation } from "react-i18next";
import vector from "../../images/vector.svg";

// Lazy-load GoogleAuthButton to defer bundle loading
const GoogleAuthButton = lazy(() => import("../../components/GoogleAuthButton"));

const SignIn: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyLayout>
      <div className="rounded-sm border border-stroke bg-white/60 shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex flex-wrap items-stretch justify-center">
          <div className="hidden w-full xl:block xl:w-1/2">
            <div className="py-17.5 px-26 text-center">
              <Link className="mb-5.5 inline-block" to="/">
                <img className="hidden dark:block" src={trulogo} alt="Logo" />
                <img className="dark:hidden" src={trulogo} alt="Logo" />
              </Link>

              <p className="text-2xl font-bold">{t("Lecturer Portal")}</p>

              <span className="mt-15 inline-block">
                <img src={vector} alt="Vector" />
              </span>
            </div>
          </div>

          <div className="flex flex-col justify-center w-full border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2 bg-black/20">
            <div className="w-full p-4 sm:p-12.5 xl:p-17.5 ">
              <h2 className="mb-9 text-lg font-bold text-black dark:text-white sm:text-title-lg text-center">
                {t("Login")}
              </h2>
              <Suspense fallback={<div className="flex justify-center py-4"><span>Loading...</span></div>}>
                <GoogleAuthButton />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </EmptyLayout>
  );
};

export default SignIn;
